import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.isVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isVisible) = $event)),
    onClosed: _ctx.onClosed,
    width: "700"
  }, {
    default: _withCtx(() => [
      _createElementVNode("h3", null, [
        _createElementVNode("span", null, _toDisplayString(_ctx.partNumber?.toLocaleUpperCase()), 1)
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: _ctx.items,
        "show-header": false,
        "max-height": "300",
        onRowClick: _ctx.selectItemFromSearchResultsClick
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "Номер OEM",
            width: "140",
            prop: "partNumber"
          }),
          _createVNode(_component_el_table_column, {
            prop: "externalName",
            label: "Наименование"
          }),
          _createVNode(_component_el_table_column, {
            prop: "manufacturer.name",
            label: "Производитель"
          })
        ]),
        _: 1
      }, 8, ["data", "onRowClick"])), [
        [_directive_loading, _ctx.searchOperaionPending]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onClosed"]))
}